export enum EmploymentType {
  FREELANCER = 'FREELANCER',
  TEMPWORKER = 'TEMPWORKER',
}
